"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconActive = IconActive;
exports.IconDelete = IconDelete;
exports.Tag = Tag;
exports.default = void 0;
var React = _interopRequireWildcard(require("react"));
var _utils = require("./utils");
var _Tooltip = _interopRequireDefault(require("./Tooltip"));
var _connect = require("./connect");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
// ----- UTIL

function iconStyle(props) {
  if (props.solid) return 'fas';
  if (props.brand) return 'fab';
  if (props.regular) return 'far';
  if (props.duotone) return 'fad';
  return 'fa';
}

// ----- COMPONENT

var Icon = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var iconProp = {
    ref: ref,
    className: (0, _utils.clsNames)('un-icon', iconStyle(props), 'fa-' + props.name, props.fixWidth && 'fa-fw', props.size && 'fa-' + props.size, props.lg && '-lg', props.className)
  };
  if (props.href) {
    iconProp.href = props.href;
    if (props.targetBlank) {
      iconProp.target = '_blank';
    }
    if (props.download) {
      iconProp.download = true;
    }
  }
  if (props.button) iconProp.className += ' un-icon-button';
  if (props.onClick) iconProp.onClick = props.onClick;
  if (props.rotate) {
    iconProp.className = (0, _utils.clsNames)(iconProp.className, function (r) {
      if (r === 90 || r === 180 || r === 270) return 'fa-rotate-' + r;
      if (r === 'v') return 'fa-flip-vertical';
      if (r === 'h') return 'fa-flip-horizontal';
      if (r === 'x') return 'fa-flip-both';
      return '';
    }(props.rotate));
  } else if (props.spin) {
    iconProp.className += props.spin === 'pulse' ? ' fa-pulse' : ' fa-spin';
  }
  if (props.ariaLabel) iconProp['aria-label'] = props.ariaLabel;
  var output = /*#__PURE__*/React.createElement(!!props.href ? 'a' : !!props.button ? 'button' : 'i', iconProp);
  if (props.tooltip) {
    return /*#__PURE__*/React.createElement(_Tooltip.default, {
      title: props.tooltip
    }, output);
  }
  return output;
});
var _default = Icon;
exports.default = _default;
function IconDelete(props) {
  return /*#__PURE__*/React.createElement(Icon, {
    name: 'trash-alt',
    lg: props.lg,
    button: true,
    ariaLabel: props.ariaLabel || 'Delete',
    onClick: props.onClick,
    className: (0, _utils.clsNames)('red', props.className),
    tooltip: props.tooltip || 'ลบทิ้ง'
  });
}
function IconActive(props) {
  var _useState = (0, React.useState)(props.active ? props.iconOn || 'lightbulb-on b orange' : props.iconOff || 'lightbulb grey'),
    _useState2 = _slicedToArray(_useState, 2),
    state = _useState2[0],
    setState = _useState2[1];
  var iconProps = {
    name: state,
    button: !props.noBotton,
    onClick: function onClick() {
      setState('spinner fa-spin');
      (0, _connect.get)(props.action).then(function (d) {
        if (d.ok) {
          setState(d.active ? props.iconOn || 'lightbulb-on b orange' : props.iconOff || 'lightbulb grey');
          if (props.onActived) props.onActived(d.active);
        } else {
          setState('exclamation-triangle red');
        }
      }).catch(function () {
        return setState('exclamation-triangle red b');
      });
    },
    className: (0, _utils.clsNames)('un-icon-active', props.className)
  };
  return /*#__PURE__*/React.createElement(Icon, iconProps);
}
function Tag(props) {
  return /*#__PURE__*/React.createElement("div", {
    className: (0, _utils.clsNames)('un-tag', props.color && '-' + props.color, props.full && '-full', props.className),
    onClick: props.onClick || undefined
  }, props.icon && /*#__PURE__*/React.createElement(Icon, {
    className: "_icon",
    name: props.icon
  }), props.label, props.onClear && /*#__PURE__*/React.createElement(Icon, {
    className: "_icon-clear",
    name: 'times',
    onClick: props.onClear
  }));
}